module.exports = __webpack_public_path__ + "img/arcos-c-img-5.cea6b3cc.jpg";